module.exports = __webpack_public_path__ + "static/media/partner-logo1.7e1bcbb8.png";